import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import GlobalStyles from "../../../assets/js/globalStyles";
import "./DeploymentWarning.css";
import * as Constants from "../../../constants/Constants";
import { updateServiceData } from "../../../redux/serviceSlice";
import { httpGetDeploymentStatus } from "../../../service/httpClient";

const DeploymentWarning = () => {
  const { bannerDisplayStatus, message } = useSelector(
    ({ service }) => service.deploymentStatus || {}
  );
  const dispatch = useDispatch();
  useEffect(() => {
    getDeploymentStatus();
  }, []);

  const getDeploymentStatus = () => {
    httpGetDeploymentStatus()
      .then((response) => {
        if (response && response.data && response.data.length > 0) {
          const deploymentBanner =
            response.data.length === Constants.BANNER_DATA_SIZE
              ? response.data
              : null;
          let displayStatus = false;
          let displayMessage = "";
          if (deploymentBanner) {
            deploymentBanner.forEach((element) => {
              if (element.key === Constants.SHOW_BANNER_KEY) {
                displayStatus = element.value;
              } else if (element.key === Constants.BANNER_MSG_KEY) {
                displayMessage = element.value;
              }
            });
            dispatch(
              updateServiceData({
                deploymentStatus: {
                  bannerDisplayStatus:
                    displayStatus === Constants.BANNER_FLAG_Y ? true : false,
                  message: displayMessage,
                },
              })
            );
          } else {
            dispatch(
              updateServiceData({
                deploymentStatus: {
                  bannerDisplayStatus: false,
                  message: "",
                },
              })
            );
          }
        }
      })
      .catch((err) => {
        console.log("error message in deploymentNotification : ", err);
        dispatch(
          updateServiceData({
            deploymentStatus: {
              bannerDisplayStatus: false,
              message: "",
            },
          })
        );
      });
  };

  return bannerDisplayStatus ? (
    <div className="warning-row">{message || ""} </div>
  ) : null;
};

export default withStyles(GlobalStyles)(DeploymentWarning);
